import React from 'react'
import { Card, CardHeader, CardBody, CardFooter } from 'reactstrap'

const CardMain = props => <Card {...props} />

CardMain.Header = CardHeader
CardMain.Body = CardBody
CardMain.Footer = CardFooter

export default CardMain
